module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-20fd1704.woff2";